import { createElementVNode as _createElementVNode, openBlock as _openBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "users-panel" }
const _hoisted_2 = { class: "users-tabs" }
const _hoisted_3 = { class: "users-tab-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UsersGestaoTab = _resolveComponent("UsersGestaoTab")!
  const _component_UsersListTab = _resolveComponent("UsersListTab")!
  const _component_UsersRolesTab = _resolveComponent("UsersRolesTab")!
  const _component_UsersOfflineEmployeesTab = _resolveComponent("UsersOfflineEmployeesTab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["utab", { active: _ctx.activeTab === 'gestao' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 'gestao'))
      }, [...(_cache[27] || (_cache[27] = [
        _createStaticVNode("<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-1fb58089><path d=\"M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\" data-v-1fb58089></path><circle cx=\"9\" cy=\"7\" r=\"4\" data-v-1fb58089></circle><path d=\"M23 21v-2a4 4 0 0 0-3-3.87\" data-v-1fb58089></path><path d=\"M16 3.13a4 4 0 0 1 0 7.75\" data-v-1fb58089></path></svg> Gestão ", 2)
      ]))], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["utab", { active: _ctx.activeTab === 'lista' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'lista'))
      }, [...(_cache[28] || (_cache[28] = [
        _createStaticVNode("<svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-1fb58089><line x1=\"8\" y1=\"6\" x2=\"21\" y2=\"6\" data-v-1fb58089></line><line x1=\"8\" y1=\"12\" x2=\"21\" y2=\"12\" data-v-1fb58089></line><line x1=\"8\" y1=\"18\" x2=\"21\" y2=\"18\" data-v-1fb58089></line><line x1=\"3\" y1=\"6\" x2=\"3.01\" y2=\"6\" data-v-1fb58089></line><line x1=\"3\" y1=\"12\" x2=\"3.01\" y2=\"12\" data-v-1fb58089></line><line x1=\"3\" y1=\"18\" x2=\"3.01\" y2=\"18\" data-v-1fb58089></line></svg> Lista de usuários ", 2)
      ]))], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["utab", { active: _ctx.activeTab === 'cargos' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 'cargos'))
      }, [...(_cache[29] || (_cache[29] = [
        _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("circle", {
            cx: "12",
            cy: "8",
            r: "4"
          }),
          _createElementVNode("path", { d: "M4 20c0-4 3.6-7 8-7s8 3 8 7" })
        ], -1),
        _createTextVNode(" Lista de cargos ", -1)
      ]))], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["utab", { active: _ctx.activeTab === 'offline' }]),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'offline'))
      }, [...(_cache[30] || (_cache[30] = [
        _createElementVNode("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          _createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" }),
          _createElementVNode("circle", {
            cx: "9",
            cy: "7",
            r: "4"
          }),
          _createElementVNode("path", { d: "M19 8h4M21 6v4" })
        ], -1),
        _createTextVNode(" Cadastro de Funcionarios Nao Logados ", -1)
      ]))], 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.activeTab === 'gestao')
        ? (_openBlock(), _createBlock(_component_UsersGestaoTab, {
            key: 0,
            accounts: _ctx.accounts,
            roles: _ctx.roles
          }, null, 8, ["accounts", "roles"]))
        : (_ctx.activeTab === 'lista')
          ? (_openBlock(), _createBlock(_component_UsersListTab, {
              key: 1,
              accounts: _ctx.accounts,
              "current-uid": _ctx.currentUid,
              "current-user-role": _ctx.currentUserRole,
              "show-account-form": _ctx.showAccountForm,
              "account-form": _ctx.accountForm,
              "account-error": _ctx.accountError,
              roles: _ctx.roles,
              "account-subordinate-options": _ctx.accountSubordinateOptions,
              "is-analyst": _ctx.isAnalyst,
              onRefreshAccounts: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('refresh-accounts'))),
              onOpenAccountForm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('open-account-form'))),
              onEditAccount: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('edit-account', $event))),
              onDeleteAccount: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('delete-account', $event))),
              onSaveAccount: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('save-account'))),
              onCloseAccountForm: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close-account-form'))),
              onUpdateAccountForm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('update-account-form', $event))),
              onAddAccountSubordinate: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('add-account-subordinate'))),
              onRemoveAccountSubordinate: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('remove-account-subordinate', $event)))
            }, null, 8, ["accounts", "current-uid", "current-user-role", "show-account-form", "account-form", "account-error", "roles", "account-subordinate-options", "is-analyst"]))
          : (_ctx.activeTab === 'cargos')
            ? (_openBlock(), _createBlock(_component_UsersRolesTab, {
                key: 2,
                roles: _ctx.roles,
                "show-role-form": _ctx.showRoleForm,
                "role-form": _ctx.roleForm,
                "role-error": _ctx.roleError,
                "is-analyst": _ctx.isAnalyst,
                onRefreshRoles: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('refresh-roles'))),
                onOpenRoleForm: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('open-role-form'))),
                onEditRole: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('edit-role', $event))),
                onSaveRole: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('save-role'))),
                onCloseRoleForm: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('close-role-form'))),
                onUpdateRoleForm: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('update-role-form', $event))),
                onAddRoleSubordinate: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('add-role-subordinate'))),
                onRemoveRoleSubordinate: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('remove-role-subordinate', $event)))
              }, null, 8, ["roles", "show-role-form", "role-form", "role-error", "is-analyst"]))
            : (_ctx.activeTab === 'offline')
              ? (_openBlock(), _createBlock(_component_UsersOfflineEmployeesTab, {
                  key: 3,
                  employees: _ctx.offlineEmployees,
                  roles: _ctx.roles,
                  "show-form": _ctx.showOfflineEmployeeForm,
                  form: _ctx.offlineEmployeeForm,
                  error: _ctx.offlineEmployeeError,
                  "is-analyst": _ctx.isAnalyst,
                  onOpenForm: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('open-offline-employee-form'))),
                  onCloseForm: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('close-offline-employee-form'))),
                  onSaveEmployee: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('save-offline-employee'))),
                  onEditEmployee: _cache[24] || (_cache[24] = ($event: any) => (_ctx.$emit('edit-offline-employee', $event))),
                  onDeleteEmployee: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('delete-offline-employee', $event))),
                  onUpdateForm: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$emit('update-offline-employee-form', $event)))
                }, null, 8, ["employees", "roles", "show-form", "form", "error", "is-analyst"]))
              : _createCommentVNode("", true)
    ])
  ]))
}